var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIconSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#587E85",
    d: "M13.3 11.64c.387 0 .7.304.7.68 0 .346-.267.632-.612.674L13.3 13H7c-.386 0-.7-.304-.7-.68 0-.346.267-.632.613-.674L7 11.64h6.3zM9.655.622c.552-.537 1.357-.746 2.11-.55.755.197 1.343.769 1.546 1.5.202.733-.014 1.514-.566 2.05l-8.75 8.498c-.09.088-.202.15-.325.18l-2.8.68c-.512.124-.977-.327-.848-.825l.7-2.72c.03-.12.094-.228.184-.316zm1.646.744c-.24-.03-.482.048-.656.217L2.033 9.946l-.37 1.439 1.48-.36 8.612-8.364c.174-.168.255-.404.224-.637l-.02-.1c-.073-.262-.285-.468-.556-.538z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconSmall);
export default __webpack_public_path__ + "static/media/edit-icon-small.4ca138309b342335b61c1512a6c5a630.svg";
export { ForwardRef as ReactComponent };